import Head from 'next/head'

import type { FC, ReactNode } from 'react'
import type { SeoProps } from '@/types'

import { useLocale } from '@/hooks/use-locale'
import { siteConfig } from '@/constants/site'

export const Seo: FC<SeoProps> = ({
    title,
    description,
    ogImage = siteConfig.ogImage
}): ReactNode => {
    const { locale, t } = useLocale()
    const siteName = t.siteName
    const pageTitle = title ? `${title} - ${siteName}` : `${siteName} - ${t.siteTagline}`
    const pageDescription = description || t.siteDescription

    return (
        <Head>
            <title>
                {pageTitle}
            </title>

            <meta name='description' content={pageDescription} />
            <meta property='og:title' content={pageTitle} />
            <meta property='og:description' content={pageDescription} />
            <meta property='og:type' content='website' />
            <meta property='og:site_name' content={siteName} />
            <meta property='og:locale' content={locale === 'hi' ? 'hi_IN' : 'en_US'} />
            <meta property='og:url' content={siteConfig.url} />
            <meta name='twitter:card' content='summary_large_image' />
            <meta name='twitter:title' content={pageTitle} />
            <meta name='twitter:description' content={pageDescription} />

            {ogImage && <meta property='og:image' content={ogImage} />}
            {ogImage && <meta name='twitter:image' content={ogImage} />}
        </Head>
    )
}
